<template>
  <v-autocomplete
    :loading="isLoading"
    :items="transportationProfiles"
    :search-input.sync="searchKey"
    :label="label"
    :placeholder="placeholder"
    :disabled="disabled"
    class="bus-selector"
    :clearable="clearable"
    :multiple="false"
    item-text="licensePlateNumber"
    item-value="id"
    hide-no-data
    no-filter
    return-object
    v-model="internalValue"
  >
    <template slot="item" slot-scope="{ item }">
      <div style="width: 100%">
        <div>{{ item.licensePlateNumber || item.shortcodeId || item.id }}</div>
        <div v-if="formatItemSubtitle(item)">
          <small>{{ formatItemSubtitle(item) }}</small>
        </div>
        <hr style="width: 100%; border: 0; border-bottom: 1px solid #ccc" />
      </div>
    </template>
    <template v-slot:selection="{ item }">
      <span
        class="selection-summary-text"
        :title="formatSelectionLabel(item)"
      >
        {{ formatSelectionLabel(item) }}
      </span>
    </template>
  </v-autocomplete>
</template>

<style scoped>
.selection-summary-text {
  display: inline-block;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bus-selector /deep/ .v-select__selections {
  flex-wrap: nowrap;
  overflow: hidden;
}
</style>

<script>
import src from './src'
export default src
</script>
